import * as Security from './authentication';

export default Security;